module.exports = __webpack_public_path__ + "static/media/pdam.4cd8a4eb.png";